import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The failing economy paradox",
  "description": "",
  "published": "2009-04-05T00:00:00.000Z",
  "redirect_from": ["/blog/the-failing-economy-paradox/swizec/488"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The whole internets and all of media for that matter are abuzz with two words lately "Failing Economy". This I believe to be a paradox and since time is, still, money, let me sum it up for you:`}</p>
    <p><strong parentName="p">{`The global economy is failing for those afraid of change and opening oportunities for everybody else.`}</strong></p>
    <p>{`In other words: all that's going on is a bit of spring cleaning, do not be alarmed.`}{`*`}{`*`}{`*`}{`*`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      